import { createAuth } from "@intility/authentication";

export const auth = createAuth({
  environment: "production",
  clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID,
  authorityOverride: {
    url: import.meta.env.VITE_KEYCLOAK_URL,
    realm: import.meta.env.VITE_KEYCLOAK_REALM,
  },
});
